import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Utils
import { RoutesConstants } from "@/main/routes/routesConstants";
import { isUserAuthenticated } from "@/main/services/storage";

// Components
import LoginArea from "./components/LoginArea";
import LoginRecoveryPassword from "./components/LoginRecoveryPassword";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";

// Styles
import { useStyles, BoxForm, BorderBoxForm, Logo } from "./styles";
import SrcImageLine from "../../assets/images/homepage/line_image_edited_1.png";

// Apis
import { useTranslateHook } from "@/main/hooks/translateHook";
import { getParamsToGetTranslates, isSubDomainQualitas } from "@/main/services/utils";
import * as S from "./styles";
import LoginScreenQualitas from "./qualitas/loginScreenQualitas";

export default function LoginPage() {
	const styles = useStyles();
	const navigate = useNavigate();

	const [hasRecoveryPassword, setHasRecoveryPassword] = useState<boolean>(false);
	const { isLoadingTranslates, translatesLocal, getTranslates } = useTranslateHook({
		fillTranslateLocal: true,
	});

	useEffect(() => {
		if (isUserAuthenticated()) {
			navigate(RoutesConstants.home);
		} else {
			const { idCultureUser, lastSyncTranslations } = getParamsToGetTranslates();
			getTranslates({ culture: idCultureUser, lastSyncTranslations });
		}
	}, [isUserAuthenticated(), navigate]);

	function toggleRecoveryPassword() {
		setHasRecoveryPassword(!hasRecoveryPassword);
	}
	const isSubDomainQualitasValue = isSubDomainQualitas();

	function renderContent() {
		if (isLoadingTranslates) {
			return <LoadingComponent />;
		}
		return hasRecoveryPassword ? (
			<LoginRecoveryPassword toggleRecoveryPassword={toggleRecoveryPassword} translatesLocal={translatesLocal} />
		) : (
			<LoginArea toggleRecoveryPassword={toggleRecoveryPassword} translatesLocal={translatesLocal} />
		);
	}

	if (isSubDomainQualitasValue) {
		return (
			<LoginScreenQualitas
				hasRecoveryPassword={hasRecoveryPassword}
				isLoadingTranslates={isLoadingTranslates}
				toggleRecoveryPassword={toggleRecoveryPassword}
				translatesLocal={translatesLocal}
			/>
		);
	}

	return (
		<div id="container" className={styles.container}>
			<BoxForm>
				<Logo />
				{renderContent()}
			</BoxForm>
			<BorderBoxForm />
			<S.ImageLine src={SrcImageLine} />
		</div>
	);
}
